// Pill chấm công trên thanh trên (prototype Shell AttPill, topbarItems): "Chưa vào ca" (cảnh báo, chỉ khi actions.canCheckIn) /
// "Đang làm · HH:mm" / "Đã ra ca HH:mm" / đơn nghỉ hôm nay (cả nửa ngày); bấm ⇒ Chấm công. Ẩn với người không chấm công (CTV)
// và trên màn hẹp (như prototype).
import { useNavigate } from '@tanstack/react-router';
import { cx, fmtTime } from '@/shared/lib';
import { useMyToday } from '@/entities/work-day';

export function AttendancePill() {
  const { data } = useMyToday();
  const navigate = useNavigate();
  if (!data || !data.tracked) return null;
  const rec = data.record;
  let label: string;
  let tone = '';
  if (rec?.checkInAt && !rec.checkOutAt) {
    label = `Đang làm · ${fmtTime(rec.checkInAt)}`;
    tone = 'good';
  } else if (rec?.checkOutAt) {
    label = `Đã ra ca ${fmtTime(rec.checkOutAt)}`;
  } else if (data.leaveToday) {
    // Có đơn đã duyệt hôm nay (cả nửa ngày) ⇒ service không cho vào ca: nhãn trung tính, không nhắc "Chưa vào ca"
    label = `${data.leaveToday.label}${data.leaveToday.half ? ' (nửa ngày)' : ''}`;
  } else if (data.actions.canCheckIn) {
    label = 'Chưa vào ca';
    tone = 'warn';
  } else return null; // không vào ca được (nhân sự đã nghỉ việc…) ⇒ không nhắc
  return (
    <span className="hide-md">
      <button type="button" className={cx('att-pill', tone)} onClick={() => void navigate({ to: '/cham-cong' })}>
        <i />
        {label}
      </button>
    </span>
  );
}
